// The products and section headers a list's grid (#items-load) has loaded, in order. The technical
// markers — the items-end anchor, the beacons — carry neither prefix and stay out of it. One
// reading for the filing flow (last_item_id) and for the next page's cursor (after): should the
// markup change, both move together.
export const PRODUCT_PREFIX = 'product_'
export const SECTION_PREFIX = 'list_section_'

export function lastLoadedItem(grid, { productsOnly = false } = {}) {
  const selector = productsOnly
    ? `:scope > [id^="${PRODUCT_PREFIX}"]`
    : `:scope > [id^="${PRODUCT_PREFIX}"], :scope > [id^="${SECTION_PREFIX}"]`
  const items = grid?.querySelectorAll(selector) ?? []
  return items[items.length - 1]
}
